"use client";

import { captureFirstTouch } from "@shared/lib/first-touch";
import { useEffect } from "react";

/**
 * Stores the first visit's referrer + landing page (first write wins).
 * Mounted in Document so every entry page is covered; SessionProvider later
 * claims the stored data onto the user record after signup.
 */
export function FirstTouchTracker() {
	useEffect(() => {
		captureFirstTouch();
	}, []);

	return null;
}
